module.exports = __webpack_public_path__ + "media/packs/loveyourwall/images/marker-9bc89e53c4c79d962b9dfe842f299ea8.svg";